import { API } from "../auth/authApi";

export const getAdsApi = (params) => {
  return API.get("/ads", { params });
};

export const createAdsApi = (data) => {
  return API.post("/ads", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateAdsApi = (id, data) => {
  return API.put(`/ads/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteAdsApi = (id) => {
  return API.delete(`/ads/${id}`);
};